import { Grid } from "@mui/material"
import { map } from "ramda"
import React from "react"
import { Field, useFormState } from "react-final-form"

import { LabeledRadio } from "@cirrus/ui-kit/src/components/atoms/labeled-radio/index.js"

import { FiltersGroup } from "./FiltersGroup"

export const RadioFilter = ({ items, name, title, key = name, defaultValue = null }) => {
  const valueFromStore = useFormState().values?.[name]

  return (
    <FiltersGroup xs={12} groupTitle={title} {...{ key }}>
      <Grid container justifyContent="start" spacing={1}>
        {/*{map(*/}
        {/*  ({ label, value }, labelIndex) => (*/}
        {/*    <Grid item xs={4} key={`li${labelIndex}`}>*/}
        {/*      <Field*/}
        {/*        name={name}*/}
        {/*        type="radio"*/}
        {/*        value={value}*/}
        {/*        initialValue={valueFromStore || defaultValue || items[0].value}>*/}
        {/*        {({ input }) => (*/}
        {/*          <LabeledRadio*/}
        {/*            {...input}*/}
        {/*            checked={input.checked}*/}
        {/*            color={"primary"}*/}
        {/*            label={label}*/}
        {/*          />*/}
        {/*        )}*/}
        {/*      </Field>*/}
        {/*    </Grid>*/}
        {/*  ),*/}
        {/*  items,*/}
        {/*)}*/}
      </Grid>
    </FiltersGroup>
  )
}
